"use client";

import React from "react";

/**
 * 툴바 구분선 컴포넌트
 */
export const ToolbarDivider: React.FC = () => (
  <div className="lumir-toolbar-divider" />
);
